import { render, staticRenderFns } from "./AnnouncementView.vue?vue&type=template&id=f71fb918&scoped=true&"
import script from "./AnnouncementView.vue?vue&type=script&lang=js&"
export * from "./AnnouncementView.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementView.vue?vue&type=style&index=0&id=f71fb918&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71fb918",
  null
  
)

export default component.exports